import React from "react";

import type { ActiveDoctorOut } from "../../services/dashboard.service";

interface Props {
  active: number;
  total: number;
  doctors?: ActiveDoctorOut[];
  onViewAll?: () => void;
}

function displayName(name: string): string {
  return /^dr\.?\s/i.test(name.trim()) ? name : `Dr. ${name}`;
}

export const ActiveDoctorsPanel: React.FC<Props> = ({ active, total, doctors = [], onViewAll }) => {
  const rows = doctors.slice(0, 5);

  return (
    <div
      className="rounded-2xl p-5 text-white shadow-sm"
      style={{ background: "linear-gradient(135deg, #60a5fa 0%, #3b82f6 55%, #2563eb 100%)" }}
    >
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold">Active Doctors</h3>
        {onViewAll ? (
          <button
            onClick={onViewAll}
            className="text-xs font-medium text-white/80 hover:text-white flex items-center gap-1"
          >
            View All <span aria-hidden>›</span>
          </button>
        ) : (
          <svg className="w-5 h-5 opacity-80" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
        )}
      </div>

      <div className="mt-3 flex items-baseline gap-1">
        <span className="text-4xl font-bold">{active}</span>
        <span className="text-base opacity-80">/{total}</span>
      </div>
      <p className="text-xs opacity-80 mt-1">Currently on duty</p>

      <ul className="mt-4 space-y-2">
        {rows.length === 0 && (
          <li className="text-xs opacity-75 px-4 py-2.5">No doctors currently on duty.</li>
        )}
        {rows.map((d) => (
          <li
            key={d.doctor_id}
            className="flex items-center justify-between rounded-xl bg-white/20 backdrop-blur px-4 py-2.5 text-sm"
          >
            <div className="min-w-0 flex-1">
              <p className="truncate font-medium">{displayName(d.name)}</p>
              {d.specialization && (
                <p className="truncate text-[11px] opacity-75">{d.specialization}</p>
              )}
            </div>
            <span className="text-[11px] font-medium px-3 py-1 rounded-full bg-white/25 text-white flex-shrink-0 ml-2">Active</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ActiveDoctorsPanel;
